import isSameDay from './is-same-day';

export { isSameDay };

export default isSameDay;
